import { Box, Card, CardContent, CardMedia, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import DoubleArrowRoundedIcon from '@mui/icons-material/DoubleArrowRounded';

import { TRss } from './constants';
import { BloxNXTIcon } from 'assets/BloxNXTIcon';

export type TRssCardProps = Pick<TRss, 'description' | 'link' | 'thumbnail' | 'title'> & {
  bodyTextLength?: number;
};

const RssImageCards = ({
  bodyTextLength = 320,
  description,
  link,
  thumbnail,
  title,
}: TRssCardProps) => {
  const formattedDescription =
    description && description?.length >= bodyTextLength
      ? description?.substring(0, bodyTextLength)
      : description;

  return (
    <Card
      elevation={0}
      sx={(theme) => ({
        p: 1,
        '.MuiLink-root.rss-card--read-more-link': {
          fontSize: '14px',
          color: `${theme.blox?.colors?.link} !important`,
          fill: theme.blox?.colors?.link,
          verticalAlign: 'middle',
          '& svg': {
            fontSize: '10px',
          },
        },
      })}
    >
      {thumbnail && link && (
        <Link
          rel="noopener"
          to={link}
          component={RouterLink}
          target="_blank"
        >
          <CardMedia
            sx={{ height: 240, borderRadius: '4px' }}
            image={thumbnail}
            title={title ?? 'RSS Card Image'}
            data-testid="rss-card-image"
          />
        </Link>
      )}

      {thumbnail && !link && (
        <CardMedia
          sx={{ height: 240, borderRadius: '4px' }}
          image={thumbnail}
          title={title ?? 'RSS Card Image'}
          data-testid="rss-card-image"
        />
      )}

      {!thumbnail && !link && (
        <Box
          sx={{
            height: 240,
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          title={title ?? 'RSS Card Image'}
          data-testid="rss-card-image-placeholder"
        >
          <BloxNXTIcon sx={{ fontSize: '6rem' }} />
        </Box>
      )}

      <CardContent
        sx={{
          maxHeight: 320,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          px: 0,
        }}
      >
        {title && link && (
          <Link
            rel="noopener"
            to={link}
            component={RouterLink}
            target="_blank"
          >
            <Typography
              gutterBottom
              variant="subtitle2"
              component="div"
            >
              {title}
            </Typography>
          </Link>
        )}

        {title && !link && (
          <Typography
            gutterBottom
            variant="subtitle2"
            component="div"
          >
            {title}
          </Typography>
        )}

        <Typography
          variant="body2"
          component="p"
          data-testid="rss-card-description"
          sx={{
            color: 'text.secondary',
          }}
        >
          {formattedDescription}
        </Typography>

        {/* Read more link. */}
        {link && (
          <Link
            className="rss-card--read-more-link"
            color="primary"
            rel="noopener"
            to={link}
            component={RouterLink}
            target="_blank"
          >
            Read More <DoubleArrowRoundedIcon fontSize="small" />
          </Link>
        )}
      </CardContent>
    </Card>
  );
};

export default RssImageCards;
